import React from 'react';
import css from './Header.module.css';
import Button from '../../UI/Button/Button';
import Content from '../../UI/HOC/Content/Content';
import { bookingUrlWithMarketingParams } from '../../utils/bookingUrlWithMarketingParams';

const Header = (props) => {
	const { logo } = props;
	const handleBooking = () => {
		window.location.href =
			bookingUrlWithMarketingParams(props.bookingLink);
	};
	return (
		<div className={css.Header}>
			<Content className={css.Content}>
				<div>
					<img src={logo} alt="workshop logo" className={css.Logo} />
				</div>
				<div className={css.HeaderMenu}>
					{/* <div className={css.HeaderMenuContent}>03 9292 9292</div> */}
					<Button
						type="menu"
						color="main"
						className={css.Book}
						onClick={handleBooking}
					>
						Book a service
					</Button>
				</div>
			</Content>
		</div>
	);
};
export default Header;
